module.exports = __webpack_public_path__ + "img/message.17800c1a.svg";